import React from 'react';
import AnuncioForm from '../components/anuncios/AnuncioForm';

const CriarAnuncio: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container-custom">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Criar Novo Anúncio
          </h1>
          <p className="text-gray-600">
            Preencha as informações abaixo para publicar seu anúncio
          </p>
        </div>

        <AnuncioForm />
      </div>
    </div>
  );
};

export default CriarAnuncio;
